import Vue from 'vue'
import VueRouter from 'vue-router'

import Landing from './components/Home.vue';
import Contact from './components/Contact.vue';

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Landing, name: 'Home' },
  { path: '/contact', component: Contact, name: 'Contact' },
]

export default new VueRouter({mode: 'history', routes})



// WEBPACK FOOTER //
// ./src/router.js